import type { ReactNode } from "react";
import type { AttentionKind, OperationState } from "../domain";

interface PulseCardProps {
  kind: AttentionKind | "fault" | "neutral";
  eyebrow: string;
  title: string;
  summary?: string;
  meta?: string;
  progress?: number;
  isNew?: boolean;
  operationState?: OperationState;
  children?: ReactNode;
}

export function PulseCard({
  kind,
  eyebrow,
  title,
  summary,
  meta,
  progress,
  isNew,
  operationState,
  children,
}: PulseCardProps) {
  const visualKind = operationState === "effective"
    ? "completed"
    : operationState === "rejected" || operationState === "timed-out" || operationState === "outcome-unknown"
      ? "fault"
      : kind;
  return (
    <article className="pulse-card" data-kind={visualKind} data-operation={operationState}>
      <header className="pulse-card__eyebrow">
        <span>{eyebrow}</span>
        {isNew && <span className="new-badge">New</span>}
      </header>
      <h3>{title}</h3>
      {summary && <p>{summary}</p>}
      {typeof progress === "number" && (
        <div className="progress" aria-label={`${progress}% complete`}>
          <span style={{ width: `${Math.max(0, Math.min(100, progress))}%` }} />
        </div>
      )}
      <footer>
        {meta && <span className="meta">{meta}</span>}
        {operationState && <span className="operation-chip">{operationState}</span>}
        {children && <div className="card-actions">{children}</div>}
      </footer>
    </article>
  );
}
